export default __webpack_public_path__ + "static/media/bobo-store-modal.c68a5383.png";